import React, { useState } from "react";
import Slider from "react-slick";
import zluri from "../../../../assets/icons/zluri.svg";
import zluri_b from "../../../../assets/icons/zluri_black.svg";
import { EnterEmail } from "../enter-email/enter-email";
import { InviteCode } from "../invite-code/invite-code";
import { SignUpForm } from "../signup-form/signup-form";
import { SignUpRequestForm } from "../signup-request-form/signup-request-form";
import { getLoginURL } from "../../../../common/auth";
import "./signup.css";
import { RequestSuccess } from "../request-success/request-success";
import { Route, Switch } from "react-router-dom";
import client_logos from "../../../../assets/zluri_client_logos_new.svg";
import zluri_gartner_badges from "../../../../assets/zluri_gartner_badges_new.svg";

const SLIDES = [
	{
		image: "https://zluri-assets-new.s3.us-west-1.amazonaws.com/Frame+39+(1)-min.webp",
		title: "Identity security and access governance for modern enterprises",
		desciption:
			"Centralize identity visibility, govern access, and reduce identity risk across your entire environment",
		subTitle: "Trusted by 200+ companies globally",
		subImage: client_logos,
		slider: false,
	},
	{
		image: "https://zluri-assets-new.s3.us-west-1.amazonaws.com/Group+1206+(1)-min.webp",
		title: "Manage access to apps across the joiner-mover-leaver lifecycle",
		desciption:
			"Automate provisioning, deprovisioning, and access requests using policy-based workflows",
		subImage: zluri_gartner_badges,
		slider: false,
	},
	{
		image: "https://zluri-assets-new.s3.us-west-1.amazonaws.com/Frame+38+(2)-min.webp",
		title: "Stay audit-ready with automated user access reviews",
		desciption:
			"Accelerate access reviews by 10x with end-to-end automation that simplifies audits and strengthens your security posture",
		slider: true,
	},
];

const SLIDES_MANAGE_VENDOR = [
	{
		title: `Zluri has streamlined our access request and access approval workflows with seamless Slack integration.
Automation has drastically cut down IT workload - what once took hours or even days for provisioning now happens in minutes.`,
		name: "Ben Tibi",
		profession: "Head of IT, Guesty",
	},
	{
		title: "Zluri helped us streamline both our compliance reviews and user lifecycle processes. It's been a massive time-saver and a critical enabler for our governance goals.",
		name: "Aaron Eiginger",
		profession: "IT Lead, Radicle Health",
	},
	{
		title: "We have searched for various solutions in the field of Identity Governance and access management, but none were as robust as Zluri. What appealed most to us was the number of integrations and the rate at which Zluri came out with new features, which indicates a healthy pace of growth and maturity.",
		name: "Omri",
		profession: "Global IT Manager, Assured Allies",
	},
];

export function SignUp(props) {
	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		autoplay: true,
		dotsClass: "slick-dots signup-desc-dots",
	};
	const settingsSub = {
		dots: false,
		infinite: true,
		speed: 200,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
	};

	const slidesManageVendor = SLIDES_MANAGE_VENDOR.map((slide, index) => (
		<div
			className="sub-slide-item  d-flex justify-content-center"
			key={index}
		>
			{slide.image && (
				<div className="sub-slide-item-image-container me-3 ms-2">
					<img src={slide.image} alt="" width={50} />
				</div>
			)}
			<div className="sub-slide-item-desc-container">
				<h3 className=" font-12  mb-2 white">{slide.title}</h3>
				<p
					className="font-10 mb-1 bold-700 "
					style={{ color: "rgb(255 255 255 / 80%)" }}
				>
					{slide.name}
				</p>
				<p
					style={{ color: "rgb(255 255 255 / 80%)" }}
					className="mb-0 o-6 font-8"
				>
					{slide.profession}
				</p>
			</div>
		</div>
	));

	const slides = SLIDES.map((slide, index) => (
		<div className="slide-item " key={index}>
			<div className="slide-item-image-container text-center d-flex align-items-center mb-2">
				<img src={slide.image} alt="" />
			</div>
			<div className="slide-item-desc-container text-center">
				<h3 className="bold-600 font-22  mb-2 white">{slide.title}</h3>
				<p
					className="font-14"
					style={{ color: "rgb(255 255 255 / 80%)" }}
				>
					{slide.desciption}
				</p>
			</div>
			{!slide.slider ? (
				<div className="slide-item-desc-sub-container text-center">
					{slide.subTitle && (
						<h4
							style={{ color: "#FFC117" }}
							className="font-600 font-12"
						>
							{slide.subTitle}
						</h4>
					)}
					<img src={slide.subImage} alt="" />
				</div>
			) : (
				<section className="sub-slider  p-3 ps-4 pe-4">
					<Slider {...settingsSub}>{slidesManageVendor}</Slider>
				</section>
			)}
		</div>
	));

	return (
		<div className="container-fluid g-0">
			<div className="row g-0 ">
				<div className="col-md-12">
					<div className="row g-0 signup-page d-flex align-items-stretch">
						<div className="col-md-7 col-sm-12 bg-primary order-2 order-md-2">
							<div className="signup-desc-container  d-flex flex-column justify-content-between">
								<header className="p-4 pb-1">
									<a
										href="https://zluri.com/"
										className="d-none d-md-block"
									>
										<img alt="" src={zluri} />
									</a>
								</header>
								<section>
									<Slider {...settings}>{slides}</Slider>
								</section>
								<div className=" d-none d-md-block"></div>
								<footer className="p-2 footer-mobile d-md-none ">
									<ul className="d-flex justify-content-center font-12 grey-1 o-6 my-2">
										<li>
											<ul className="d-flex">
												<li className="me-3">
													<a
														className="text-reset text-decoration-none"
														rel="noreferrer"
														href="https://www.zluri.com/terms-and-conditions"
														target="_blank"
													>
														Terms and Conditions
													</a>
												</li>
												<li>
													<a
														className="text-reset text-decoration-none"
														rel="noreferrer"
														href="https://www.zluri.com/privacy-policy"
														target="_blank"
													>
														Privacy Policy
													</a>
												</li>
											</ul>
										</li>
									</ul>
								</footer>
							</div>
						</div>
						<div className="col-md-5 col-sm-12 order-1 order-md-2 signup-container p-5 pb-0 d-flex flex-column justify-content-between">
							<header className="d-flex justify-content-between">
								<a
									href="https://zluri.com/"
									className="d-md-none"
								>
									<img alt="" src={zluri_b} />
								</a>
								<a className="d-none d-md-block"></a>
								<a
									className="btn btn-primary-inverse font-13"
									href={getLoginURL()}
								>
									Log in
								</a>
							</header>
							<section>
								<div className="signup-section">
									<Switch>
										<Route exact path="/">
											<EnterEmail />
										</Route>
										<Route exact path="/request">
											<SignUpRequestForm />
										</Route>
										<Route exact path="/request-sent">
											<RequestSuccess />
										</Route>
										<Route exact path="/signup">
											<SignUpForm />
										</Route>
										<Route exact path="/invite-code">
											<InviteCode />
										</Route>
									</Switch>
								</div>
							</section>
							<div className="d-md-none"></div>
							<footer
								className="p-2 d-none d-md-block"
								style={{
									borderTop: "1px solid #ddd",
								}}
							>
								<ul className="d-flex justify-content-center font-12 grey-1 o-6 my-2">
									<li>
										<ul className="d-flex">
											<li className="me-3">
												<a
													className="text-reset text-decoration-none"
													rel="noreferrer"
													href="https://www.zluri.com/terms-and-conditions"
													target="_blank"
												>
													Terms and Conditions
												</a>
											</li>
											<li>
												<a
													className="text-reset text-decoration-none"
													rel="noreferrer"
													href="https://www.zluri.com/privacy-policy"
													target="_blank"
												>
													Privacy Policy
												</a>
											</li>
										</ul>
									</li>
								</ul>
							</footer>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
